import { render, staticRenderFns } from "./approve-detail.vue?vue&type=template&id=59c4c286&scoped=true"
import script from "./approve-detail.vue?vue&type=script&lang=js"
export * from "./approve-detail.vue?vue&type=script&lang=js"
import style0 from "./approve-detail.vue?vue&type=style&index=0&id=59c4c286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c4c286",
  null
  
)

export default component.exports